import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1H5V2.5a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5V5h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zM2 9.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-1 0V10H2.5a.5.5 0 01-.5-.5zm7 0a.5.5 0 01.5-.5h3a.5.5 0 010 1H10v2.5a.5.5 0 01-1 0v-3z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgExitFullScreen = styled(BaseComponent)`
  outline: none;
`
export default SvgExitFullScreen
